import React from 'react'

export default function ContentContainer ({ children }) {
  return <div className='main-content'>
    {children}
  </div>
}